export default "__VITE_ASSET__f6f50d4a__"